import { createDocument } from '../services/documents';
import doRequest, { TIMEZONE_GMT } from '../services/request';

const getReportQuota = async (): Promise<any> => {
  const response = await doRequest('report/quota', { method: 'GET' });

  if (response?.status !== 200) {
    return { enforced: false };
  }

  return response.json();
};

const createUnifiedReport = async (assessmentReportForm: any): Promise<any> => {
  const isByApartment = Boolean(assessmentReportForm?.is_by_apartment);

  const data = await createDocument(
    assessmentReportForm,
    `report/assessment/unified?isByApartment=${isByApartment}`,
  );
  return data;
};

const createSeparatedReport = async (
  assessmentReportForm: any,
): Promise<any> => {
  const data = await createDocument(
    assessmentReportForm,
    'report/assessment/users',
  );
  return data;
};

const createXlsxChargerReport = async (
  active,
  chargeBoxGroupPk,
  tenantPk,
  searchInput,
  online,
): Promise<any> => {
  let chargePointsUrl = `report/xlsx/chargepoints?active=${active}`;

  if (chargeBoxGroupPk) {
    chargePointsUrl = chargePointsUrl.concat(
      `&chargeBoxGroupPk=${chargeBoxGroupPk}`,
    );
  }

  if (tenantPk) {
    chargePointsUrl = chargePointsUrl.concat(`&tenantPk=${tenantPk}`);
  }

  if (searchInput) {
    chargePointsUrl = chargePointsUrl.concat(`&searchInput=${searchInput}`);
  }

  if (online) {
    chargePointsUrl = chargePointsUrl.concat(`&online=${online}`);
  }

  const data = await createDocument(null, chargePointsUrl);
  return data;
};

const createXlsxTransactionReport = async ({
  chargeBoxPk,
  fromDate,
  toDate,
  userOcppTag,
  paymentStatus,
  searchInput,
  isVehicle,
  isVoucher100,
}): Promise<any> => {
  const data = await createDocument(
    null,
    `report/xlsx/transactions?chargeBoxPK=${chargeBoxPk}&fromDate=${fromDate}&toDate=${toDate}&ocppUserTag=${userOcppTag}&paymentStatus=${paymentStatus}&searchInput=${searchInput}&isVehicle=${isVehicle}&timeZone=${TIMEZONE_GMT}&isVoucher100=${isVoucher100}`,
  );
  return data;
};

const createXlsxMeterValuesReport = async (transaction_pk): Promise<any> => {
  const data = await createDocument(
    null,
    `report/xlsx/transactions/${transaction_pk}/meter-values`,
  );
  return data;
};

const createXlsxUserReport = async ({
  activeUsers,
  searchInput,
}): Promise<any> => {
  const data = await createDocument(
    null,
    `report/xlsx/users?activeUsers=${activeUsers}&searchInput=${searchInput}`,
  );
  return data;
};

const createXlsxOcppTagReport = async ({
  tenantPk,
  searchInput,
}): Promise<any> => {
  const data = await createDocument(
    null,
    `report/xlsx/ocpptags?tenantPk=${tenantPk}&searchInput=${searchInput}`,
  );
  return data;
};

export {
  getReportQuota,
  createUnifiedReport,
  createSeparatedReport,
  createXlsxChargerReport,
  createXlsxTransactionReport,
  createXlsxMeterValuesReport,
  createXlsxUserReport,
  createXlsxOcppTagReport,
};
